module.exports = __webpack_public_path__ + "img/tel-icon.544e2062.png";